import { receiveResults } from './results';
import { submitSearchRequest } from '../utils/api';

export const SUBMIT_QUERY = 'SUBMIT_QUERY';

function submitQuery(query) {
  return {
    type: SUBMIT_QUERY,
    query
  }
}

export function handleSubmitQuery(query, params, append) {
  return (dispatch) => {
    dispatch(submitQuery(query))
    return submitSearchRequest(query, params)
      .then((results) => {
        dispatch(receiveResults(results, append))
      })
  }
}



// WEBPACK FOOTER //
// ./src/actions/query.js